import TourPage from "@/components/TourPage";

export default function NyungweKivu4Day() {
  return (
    <TourPage
      tourId="rwanda/nyungwe-kivu-4-day"
      title="4 Days Nyungwe Forest National Park and Lake Kivu Tour"
      duration="4 Days / 3 Nights"
      price="Contact for price"
      image="/nyunguwemonkey.jpeg"
      description="Explore the pristine Nyungwe Forest National Park, home to diverse primates and birds, combined with the serene beauty of Lake Kivu."
      itinerary={[
        {
          day: 1,
          title: "Kigali to Nyungwe Forest",
          description: "Journey to the ancient Nyungwe Forest.",
          activities: [
            "Morning pickup from Kigali",
            "Scenic drive to Nyungwe Forest",
            "Visit tea plantations en route",
            "Evening nature walk near the lodge"
          ],
          accommodation: "Nyungwe Forest Lodge or similar",
          meals: "Lunch, Dinner"
        },
        {
          day: 2,
          title: "Chimpanzee Tracking",
          description: "Track and observe our closest relatives.",
          activities: [
            "Early morning chimpanzee tracking",
            "Afternoon canopy walk",
            "Bird watching",
            "Evening relaxation at lodge"
          ],
          accommodation: "Nyungwe Forest Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Lake Kivu Experience",
          description: "Travel to and explore Lake Kivu.",
          activities: [
            "Morning drive to Lake Kivu",
            "Boat ride on the lake",
            "Visit local fishing villages",
            "Sunset viewing"
          ],
          accommodation: "Lake Kivu Serena Hotel or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Return to Kigali",
          description: "Journey back to the capital.",
          activities: [
            "Morning leisure at Lake Kivu",
            "Drive back to Kigali",
            "City tour if time permits",
            "Transfer to airport"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "Chimpanzee permit",
        "Canopy walk fees",
        "All ground transportation",
        "English speaking guide",
        "Park entrance fees",
        "Boat ride on Lake Kivu",
        "Accommodation as listed",
        "Meals as specified"
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips for guides",
        "Drinks and beverages",
        "Optional activities"
      ]}
    />
  );
}
